import * as actionTypes from 'constants/ActionTypes';

const domains = (state = { items: [] }, action) => {
    switch (action.type) {
        case actionTypes.CONNECT_NEW_DOMAIN_TO_USER.REQUEST:
            return {
                ...state,
            };
        case actionTypes.CONNECT_NEW_DOMAIN_TO_USER.SUCCESS:
            return {
                ...state,
            };
        case actionTypes.CONNECT_NEW_DOMAIN_TO_USER.FAILURE:
            return {
                ...state,
            };

        case actionTypes.DELETE_DOMAIN.REQUEST:
            return {
                ...state,
            };
        case actionTypes.DELETE_DOMAIN.SUCCESS: {
            return {
                ...state,
            };
        }
        case actionTypes.DELETE_DOMAIN.FAILURE:
            return {
                ...state
            };

        case actionTypes.GET_LIST_DOMAIN.REQUEST:
            return {
                ...state,
            };
        case actionTypes.GET_LIST_DOMAIN.SUCCESS: {
            return {
                items: action.data,
            };
        }
        case actionTypes.GET_LIST_DOMAIN.FAILURE:
            return {
                ...state
            };
        default:
            return state;
    }
};

export default domains;



// WEBPACK FOOTER //
// ./app/reducers/domains.js